import {
  lastSetXTokenTimeStorage,
  reflectionStorage,
  store,
  xRbacTokenStorage,
} from '@/store'
import { moment } from '@seiue/moment'
import { Toast } from '@seiue/ui'
import { Avatar } from 'antd'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { $t } from 'packages/locale'
import { User, UserDomainEnum, authApi } from 'packages/sdks-next/growp'
import { AnyValueObj } from 'packages/types'
import { getUrlParams } from 'packages/utils'
import React from 'react'
import styled from 'styled-components'

import { getFormalUserJumpUrl } from '../user/utils'

/**
 * 多用户选择登录
 *
 * @param param - 参数
 * @param param.user - 用户信息
 * @param param.loginParam - 登录参数
 * @returns 组件
 */
export const SelectedUser: React.FC<{
  user?: User
  loginParam?: AnyValueObj
}> = ({ user, loginParam }) => {
  const { reflections } = user || {}
  const openLogin = {
    clientId: getUrlParams('client_id'),
    scope: getUrlParams('scope'),
    state: getUrlParams('state'),
    redirectUri: getUrlParams('redirect_uri'),
    responseType: getUrlParams('response_type'),
    nonce: getUrlParams('nonce'),
  }

  return (
    <Wrapper>
      <Title>{$t('选择身份')}</Title>
      <Description>
        {$t('检测到你的手机号绑定了多个学生，请选择登录')}
      </Description>
      {reflections?.map((reflection) => (
        <UserWrapper
          key={reflection.id}
          onClick={async () => {
            try {
              const { data } = await authApi.login(
                UserDomainEnum.Formal,
                {
                  ...loginParam,
                  multiRid: reflection.id,
                  openLogin,
                },
                { omitAuthorizationHeader: true }
              )

              store.set(reflectionStorage, data)
              authApi
                .checkDataToken()
                .then(({ data }) => {
                  store.set(xRbacTokenStorage, data)
                  store.set(lastSetXTokenTimeStorage, moment().toISOString())
                })
                // 不管 checkDataToken 是否成功，都进行下一步界面，不影响主流程
                .finally(() => {
                  location.href = getFormalUserJumpUrl(reflection.role)
                })
            } catch (e: any) {
              const { data } = e.response
              Toast.error(data?.message)
            }
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <Avatar
              size={32}
              src={reflection.avator}
            >
              {reflection.name.slice(-2)}
            </Avatar>
            <div>{reflection.name}</div>
          </div>
          <GrowpIcon
            name="RightArrow"
            size={16}
            color="#455766"
          />
        </UserWrapper>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Title = styled.div`
  font-size: 24px;
  color: ${(props) => props.theme.text._1};
`

const Description = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.text._1};
`

const UserWrapper = styled.div`
  width: 336px;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.background._3};
  cursor: pointer;
  .icon-wrapper {
    display: none;
  }

  &:hover {
    background-color: ${(props) => props.theme.background._2};
    .icon-wrapper {
      display: block;
    }
  }
`
